export default __webpack_public_path__ + "static/media/scratch.9f9d7d65.jpg";